import styled from 'styled-components';
import { Button, Input, Modal, Spin, Space } from 'antd';
import { blueLink, grayDark05 } from '../../styles/colors';

export const ProductTagsModalStyled = styled(Modal)`
    width: 680px !important;

    .ant-modal-body {
        padding: 32px 40px 40px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }

    .ant-divider-horizontal {
        margin-top: 28px;
        margin-bottom: 21px;
    }
`;

export const ProductTagsSpin = styled(Spin)`
    top: 0 !important;
`;

export const NewTag = styled('div')`
    display: flex;
    align-items: end;
    .ant-input {
        margin-right: 0px;
    }
`;

export const SeeAllTagsButton = styled(Button)`
    padding-left: 0px;
    white-space: nowrap;
    color: ${blueLink};
`;

export const SearchInput = styled(Input)`
    padding: 5px 8px;
    color: ${grayDark05};
    font-family: "Proxima Nova";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

export const ModalContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TitleContainer = styled('div')`
    margin-bottom: 24px;
`;

export const SearchRow = styled('div')`
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-top: 5px;

    .tag-picker-dropdown .ant-select-item.tag-picker-divider {
        padding: 3px 12px;
        min-height: 0;
        cursor: default;
    }
`;

export const SelectedTagsContainer = styled('div')`
    margin-bottom: 12px;
`;

export const StyledSpace = styled(Space)`
    gap: 8px;
`;

export const Section = styled('div')`
    margin-top: 12px;
`;

export const ColorPickerWrap = styled('span')`
    display: flex;
    align-items: center;
    gap: 4px;
`;
